// ##### 25-02-05 Komarov
import parse from 'html-react-parser';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../hooks/useLocalizedText.js';

// ##### Komarov 2025-07-14
const NoSearchResultMessageEnd = ({ noTextMessage }) => {
  // ##### Komarov 2025-08-05
  const NoSearchResultMessageEnd = useLocalizedText('NoSearchResultMessageEnd');
  const noSearchResultMessageEnd = parse(
    NoSearchResultMessageEnd
  );

  return (
    <h3 className="LoadingText" data-component="NoSearchResultMessageEnd">
      {/* ##### 25-01-28 Komarov */}
      {noTextMessage ? null : noSearchResultMessageEnd}
    </h3>
  );
};

// ##### 25-05-21 Komarov
export default NoSearchResultMessageEnd;
